import axiosClient from "../../network";

export default class transactionsService {
  static async getTransactions(params) {
    return axiosClient
      .get("/user/transactions", {
        params,
        cache: {
          maxAge: 0
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }

  static getAllBets(params) {
    return axiosClient
      .get("/earGaming/getAllBets", {
        params,
        cache: {
          maxAge: 0
        }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        if (error.data) {
          return { error: error.data };
        }
        return {
          error
        };
      });
  }
}
